<app-modal-mensagem
  *ngIf="sucesso"
  tipo="sucesso"
  titulo="Sucesso!"
  mensagem="Obra contratada com sucesso!"
  textoConfirmar="Continuar"
  (confirmar)="continuar()"
></app-modal-mensagem>

<div class="modal-panel-tarefa" *ngIf="!sucesso">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Obra contratada</h2>
        <p class="modal-subtitle">Informe o responsável e os detalhes</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="close.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="form-label" for="taskDescription">Descreva a tarefa</label>
      <textarea
        id="taskDescription"
        class="form-textarea"
        [(ngModel)]="taskDescription"
        placeholder="Descreva a tarefa..."
        rows="4"
      ></textarea>
    </div>

    <div class="form-group">
      <label class="form-label" for="responsavel">
        Responsável
        <span class="required">*</span>
      </label>
      <app-filtro-responsavel
        [responsaveis]="responsavel"
        [value]="responsavelSelecionado"
        (valueChange)="responsavelSelecionado = $event; campoObrigatorioErro = false"
        placeholder="Selecione o responsável"
        placeholderBusca="Buscar responsável"
      ></app-filtro-responsavel>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !responsavelSelecionado">
        Campo obrigatório!
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="clear()">
      Limpar dados
    </button>
    <button
      class="btn-primary"
      type="button"
      (click)="atualizarObraContratada()"
      [disabled]="carregando"
    >
      Obra contratada
    </button>
  </div>
</div>
